<template>
  <div class="Features padding">

    <h1>
      Features
    </h1>

    <div class="columns">

      <div>
        <h2>Live captions</h2>
        <p>
          Automatic speech-to-text captions in the browser.
        </p>
        <p>
          Or use built-in manual transcription.
        </p>
      </div>
      <div>
        <h2>Popular tools</h2>
        <p>
          Stream captions to video calls (Zoom, Google Meets, Jitsi, etc.) and streaming software/platforms (OBS, Streamlabs, YouTube, Facebook, etc.)
        </p>
      </div>
      <div>
        <h2>40+ languages</h2>
        <p>
          Wide language and dialect support.
        </p>
      </div>
      <div>
        <h2>Multi-user</h2>
        <p>
          Easily share captions between any user across the web.
        </p>
      </div>
      <div>
        <h2>Raise your hand</h2>
        <p>
          Raise your hand, share your mood, call for coffee breaks, etc.
        </p>
      </div>
      <div>
        <h2>Share between tabs</h2>
        <p>
          Show captions in any browser tab, using the <router-link :to="{ name: 'Extension'}">Textify web extension</router-link>.
        </p>
      </div>

    </div>
    <hr />
    <h1 class="center">⬇️</h1>
    <hr />

    <h1>
      Use cases
    </h1>

    <div class="columns">

      <div>
        <h2>Presentations</h2>
        <p>
          Live captions for increased accessibility.
        </p>
        <p>
          As overlay or next to the main screen. And in any audience member's phone.
        </p>
      </div>
      <div>
        <h2>Conferences</h2>
        <p>
          Display speakers' captions on any screen in any room.
        </p>
      </div>
      <div>
        <h2>Public speeches</h2>
        <p>
          Live captions for video streams, using popular broadcasting tools.
        </p>
      </div>
      <div>
        <h2>In the classroom</h2>
        <p>
          Live teacher transcripts for absent students.
        </p>
      </div>
      <div>
        <h2>Online meetings</h2>
        <p>
          Keep record of what has been said and decided.
        </p>
      </div>
      <div>
        <h2>And much more</h2>
        <p>
          Use it however you like!
        </p>
      </div>

    </div>

    <hr />
    <h1 class="center">💡</h1>
    <hr />

    <div id="request">
      <h1>Got an idea?</h1>
      <p>
        Do you miss some useful functionality? Do you have an idea for a cool feature?
      </p>
      <p>
        Add a suggestion below and upvote other users' requests. You can also <a href="mailto:martin@interaktivarum.se">send me an email</a>.
      </p>
        <div class="pollly-embed" data-id="G4bNz750"></div>
    </div>

    <hr />

    <h3>Found a bug?</h3>
    <p>
       Please contact me at <a href="mailto:martin@interaktivarum.se">martin@interaktivarum.se</a>.
    </p>

  </div>
</template>

<script>
// @ is an alias to /src

import {addScript} from '@/utils.js'

export default {
  name: 'Integrity',
  components: {
  },
  data: function () {
    return {
    }
  },
  methods: {
  },
  mounted: function () {
    addScript('https://poll.ly/scripts/embed.js',true)
  }
}
</script>

<style lang="scss" scoped>

  .columns{
    flex-wrap: wrap;
  }

  .columns > div{
    flex: 1 0 200px;
    margin-right: 10px;
  }

  .pollly-embed{
    background: DodgerBlue;
    padding: 10px;
    text-align: center;
  }

  h1{
  }

  #request{
    min-height: 500px;
  }

</style>
